var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "clearfix", staticStyle: { display: "inline-block" } },
    [
      _c(
        "button",
        {
          staticClass: "btn btn--darkblue",
          attrs: { type: "button", id: "settings-engineers-add-group" },
          on: {
            click: function ($event) {
              return _vm.init()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("action.add")))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "groupSettingAddModal",
          staticClass: "reveal",
          attrs: { id: "groupSettingAddModal", "data-reveal": "" },
        },
        [
          _c("div", { staticClass: "modal-container" }, [
            _c("div", [
              _c(
                "label",
                {
                  staticClass: "confirm-header tender-font",
                  attrs: { id: "settings-engineers-add-group-label" },
                },
                [_vm._v(_vm._s(_vm.$t("settings.addGroup")))]
              ),
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "label",
                {
                  staticClass: "tender-font emphasis required-flag",
                  attrs: { id: "settings-engineers-add-group-name" },
                },
                [_vm._v(_vm._s(_vm.$t("settings.groupName")))]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.group.name,
                    expression: "group.name",
                  },
                ],
                class: {
                  "is-invalid-input":
                    _vm.apprErrHint && _vm.group.name.trim().length === 0,
                },
                attrs: {
                  type: "text",
                  id: "settings-engineers-add-group-name-value",
                  required: "",
                },
                domProps: { value: _vm.group.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.group, "name", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "label",
                {
                  staticClass: "tender-font  emphasis required-flag",
                  attrs: { id: "settings-engineers-add-group-description" },
                },
                [_vm._v(_vm._s(_vm.$t("description")))]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.group.note,
                    expression: "group.note",
                  },
                ],
                class: {
                  "is-invalid-input":
                    _vm.apprErrHint && _vm.group.note.trim().length === 0,
                },
                attrs: {
                  type: "text",
                  id: "settings-engineers-add-group-description-value",
                  required: "",
                },
                domProps: { value: _vm.group.note },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.group, "note", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _vm.apprErrHint
            ? _c(
                "span",
                { staticClass: "form-error is-visible appr-error-message" },
                [_vm._v("\n      " + _vm._s(_vm.apprErrHint) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row align-right nav_btn" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button", "aria-label": "Close reveal" },
                on: {
                  click: function ($event) {
                    return _vm.closeAddGroupModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.addGroup()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.add")))]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }